"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.UserOrganisation = exports.UserDocument = void 0;
var user_document_1 = require("./user-document");
__createBinding(exports, user_document_1, "UserDocument");
var user_organisation_1 = require("./user-organisation");
__createBinding(exports, user_organisation_1, "UserOrganisation");
